export const providerConstants = {
  GETALL_PROVIDERS_REQUEST: 'GETALL_PROVIDERS_REQUEST',
  GETALL_PROVIDERS_SUCCESS: 'GETALL_PROVIDERS_SUCCESS',
}